'use client';

import { Box, freddyTheme, Typography } from '@coolblue-development/freddy';
import {
  ProductTitle,
  ProductTitleTitle,
  SelectableBox
} from '@coolblue-development/next-patterns/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';

type DefaultOptionCardProps = {
  title?: string;
  description: string;
  disabled?: boolean;
};

const DefaultOptionCard = ({ title, description, disabled }: DefaultOptionCardProps) => {
  const { isInternalUser } = useRequestContext();

  return (
    <SelectableBox
      value='default'
      disabled={disabled}
      sx={{
        gridColumn: 'span 12',
        gridTemplateRows: 'min-content',
        [freddyTheme.breakpoint.minWidth('md')]: {
          '&:nth-last-of-type(odd)': {
            marginTop: freddyTheme.spacing[400],
            gridRow: '3'
          },
          '&:nth-last-of-type(even)': {
            gridColumn: 'span 6',
            gridRow: 'span 2'
          }
        },
        [freddyTheme.breakpoint.minWidth('lg')]: {
          '&:nth-last-of-type(odd), &:nth-last-of-type(even)': {
            marginTop: 0,
            gridRow: 'span 2',
            gridColumn: 'span 4'
          }
        }
      }}
    >
      <ProductTitle>
        <ProductTitleTitle size={{ xs: 'small', md: 'medium' }}>{title ?? ''}</ProductTitleTitle>
      </ProductTitle>
      <Box data-cy={isInternalUser ? 'no-option-card' : undefined}>
        {description && (
          <Typography variant='body' mt={100}>
            {description}
          </Typography>
        )}
      </Box>
    </SelectableBox>
  );
};

export default DefaultOptionCard;
